import { render, staticRenderFns } from "./chat.html?vue&type=template&id=5fa5b646&scoped=true&"
import script from "./chat.js?vue&type=script&lang=js&"
export * from "./chat.js?vue&type=script&lang=js&"
import style0 from "./chat.scss?vue&type=style&index=0&id=5fa5b646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5b646",
  null
  
)

export default component.exports